var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var counter_exports = {};
__export(counter_exports, {
  Counter: () => Counter
});
module.exports = __toCommonJS(counter_exports);
var import_collector = require("./collector");
class Counter extends import_collector.Collector {
  inc(labels) {
    this.add(1, labels);
    return this;
  }
  add(amount, labels) {
    if (amount < 0) {
      throw new Error(
        `Expected increment amount to be greater than -1. Received: ${amount}`
      );
    }
    const metric = this.get(labels);
    this.set(metric ? metric.value + amount : amount, labels);
    return this;
  }
  reset(labels) {
    this.set(0, labels);
  }
}
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vc3JjL2NvdW50ZXIudHMiXSwKICAic291cmNlc0NvbnRlbnQiOiBbImltcG9ydCB7IENvbGxlY3RvciB9IGZyb20gXCIuL2NvbGxlY3RvclwiO1xuaW1wb3J0IHsgQ291bnRlclZhbHVlLCBMYWJlbHMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY2xhc3MgQ291bnRlciBleHRlbmRzIENvbGxlY3RvcjxDb3VudGVyVmFsdWU+IHtcbiAgaW5jKGxhYmVscz86IExhYmVscyk6IHRoaXMge1xuICAgIHRoaXMuYWRkKDEsIGxhYmVscyk7XG4gICAgcmV0dXJuIHRoaXM7XG4gIH1cblxuICBhZGQoYW1vdW50OiBudW1iZXIsIGxhYmVscz86IExhYmVscyk6IHRoaXMge1xuICAgIGlmIChhbW91bnQgPCAwKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoXG4gICAgICAgIGBFeHBlY3RlZCBpbmNyZW1lbnQgYW1vdW50IHRvIGJlIGdyZWF0ZXIgdGhhbiAtMS4gUmVjZWl2ZWQ6ICR7YW1vdW50fWAsXG4gICAgICApO1xuICAgIH1cbiAgICBjb25zdCBtZXRyaWMgPSB0aGlzLmdldChsYWJlbHMpO1xuICAgIHRoaXMuc2V0KG1ldHJpYyA/IG1ldHJpYy52YWx1ZSArIGFtb3VudCA6IGFtb3VudCwgbGFiZWxzKTtcblxuICAgIHJldHVybiB0aGlzO1xuICB9XG5cbiAgcmVzZXQobGFiZWxzPzogTGFiZWxzKTogdm9pZCB7XG4gICAgdGhpcy5zZXQoMCwgbGFiZWxzKTtcbiAgfVxufVxuIl0sCiAgIm1hcHBpbmdzIjogIjs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsdUJBQTBCO0FBR25CLE1BQU0sZ0JBQWdCLDJCQUF3QjtBQUFBLEVBQ25ELElBQUksUUFBdUI7QUFDekIsU0FBSyxJQUFJLEdBQUcsTUFBTTtBQUNsQixXQUFPO0FBQUEsRUFDVDtBQUFBLEVBRUEsSUFBSSxRQUFnQixRQUF1QjtBQUN6QyxRQUFJLFNBQVMsR0FBRztBQUNkLFlBQU0sSUFBSTtBQUFBLFFBQ1IsOERBQThELE1BQU07QUFBQSxNQUN0RTtBQUFBLElBQ0Y7QUFDQSxVQUFNLFNBQVMsS0FBSyxJQUFJLE1BQU07QUFDOUIsU0FBSyxJQUFJLFNBQVMsT0FBTyxRQUFRLFNBQVMsUUFBUSxNQUFNO0FBRXhELFdBQU87QUFBQSxFQUNUO0FBQUEsRUFFQSxNQUFNLFFBQXVCO0FBQzNCLFNBQUssSUFBSSxHQUFHLE1BQU07QUFBQSxFQUNwQjtBQUNGOyIsCiAgIm5hbWVzIjogW10KfQo=
